export default {
  inOfficeDays: "{n} Tag im Büro pro Woche | {n} Tage im Büro pro Woche",
  allowedTimezoneOffset: "+/- {offset} Stunden",
}